import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileCompletionService } from './profile-completion.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompletionGuard implements CanActivate {
  
  constructor(
    private profileCompletionService: ProfileCompletionService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // Check if this is the profile page itself - if so, allow access
    if (state.url.includes('/home/profile')) {
      return new Observable(observer => observer.next(true));
    }

    // Check if this is a route that should bypass profile completion check
    if (state.url.includes('/home/user-cvs')) {
      return new Observable(observer => observer.next(true));
    }

    // ATS Scan (REQ-CV-031) is a standalone analysis tool - it works on
    // any uploaded PDF and never reads the user's Profile, so it has no
    // business being gated on profile completeness. Same reasoning as
    // the /home/user-cvs bypass above.
    if (state.url.includes('/home/ats-scan')) {
      return new Observable(observer => observer.next(true));
    }

    // recent-jobs (POC) - a third-party job listing, no matching against
    // the user's Profile yet. Same reasoning as the ats-scan bypass above.
    if (state.url.includes('/home/recent-jobs')) {
      return new Observable(observer => observer.next(true));
    }

    // Root CV screens must stay reachable for a brand-new account that has
    // neither a Root CV nor a complete profile yet (chamba-ai#268: Root CV
    // is the first thing a new user fills in) - same bypass
    // UserCvPresenceGuard already applies for this exact reason. Without
    // it, a user UserCvPresenceGuard just routed to /home/root-cv/start
    // would immediately get bounced again to /home/profile by this guard.
    if (state.url.includes('/home/root-cv')) {
      return new Observable(observer => observer.next(true));
    }

    // For all other routes, check profile completion
    return this.profileCompletionService.checkProfileCompletion(true);
  }
}
